import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    //
    // Education Slide
    field: 'mpEducationSlide1',
    type: 'info',
    educationalSlide:
      'We have a few questions to ask you before your meal planning call. The more detailed your answers are, the more productive our call will be. Please answer the following questions to the best of your ability.',
    label: '',
    answer: {}
  },

  {
    label:
      'What high-protein foods do you like? If you are unsure of what a high-protein food is, please use your Meal Planning Prep Kit.',
    field: 'mpHighProteinFoodsYouLike',
    type: 'info',
    required: true,
    answer: {
      type: 'text',
      name: 'highProteinFoodsYouLike',
      required: true,
      placeholder: 'Please describe'
    }
  },

  {
    label: 'What vegetables and fruits do you like?',
    field: 'mpVegetablesFruitYouLike',
    type: 'info',
    required: true,
    answer: {
      type: 'text',
      name: 'vegetablesFruitYouLike',
      required: true,
      placeholder: 'Please describe'
    }
  },

  {
    label:
      'What high-fiber grains and starches do you like? If you are unsure of what a high-fibre starch or grain is, please use your Meal Planning Prep Kit.',
    field: 'mpHighFiberGrains',
    type: 'info',
    required: true,
    answer: {
      type: 'text',
      name: 'highFiberGrains',
      required: true,
      placeholder: 'Please describe'
    }
  },

  {
    label:
      'What foods do you dislike? Please include only foods that you would never eat.',
    field: 'mpFoodsYouDislike',
    type: 'info',
    required: true,
    answer: {
      type: 'text',
      name: 'foodsYouDislike',
      required: true,
      placeholder: 'Please describe'
    }
  },

  {
    //
    // Education Slide
    field: 'mpEducationSlide2',
    type: 'info',
    educationalSlide:
      "Thanks for your answers - we'll review on our upcoming call.",
    label: '',
    answer: {}
  }
];
export default questionsModels;
